module.exports = __webpack_public_path__ + "img/a621ff3.png";